<script setup>
const props = defineProps({
  type: String,
  item: Object,
  id: [Number, String],
  title: String,
  reviews: Object,
  activeId: [Number, String],
});
</script>

<template>
  <div
    class="w-full md:w-1/2 flex grid-tiles__item"
    :class="'grid-tiles__item--' + type"
  >
    <div class="relative w-full pt-100p">
      <div class="absolute inset-0 w-full h-full flex flex-wrap">
        <!-- activeID = {{ activeId }} <br />itemID = {{ item?.id }} -->

        <Tile
          v-if="type === 'project'"
          size="2x2"
          :type="item?.type ?? null"
          :detail="item?.detail ?? null"
          :title="item?.title ?? null"
          :subtitle="item?.subtitle ?? null"
          :url="item?.url ?? null"
          :slug="item?.slug ?? null"
          :image="item?.image ?? null"
          :video="item?.video ?? null"
          :fade="item?.fade ?? false"
          :bgColor="item?.bgColor ?? null"
          :active="activeId !== '' && activeId === item?.id"
          :class="item.hasContent ? '' : 'tile--empty'"
        />
        <TileReview v-if="type === 'review'" :reviews="reviews" :id="id" />
        <TileStream v-if="type === 'livestream'" :id="id" :title="title" />
      </div>
    </div>
  </div>
</template>

<style>
.grid-tiles__item--review {
  > div {
    @apply pt-0 md:pt-100p;

    > div {
      @apply relative md:absolute;

      .tile {
        @apply pt-0 md:pt-100p;

        .tile__inner {
          @apply relative inset-0 p-xs md:absolute md:inset-[10px] md:p-0;

          .swiper-reviews {
            @apply relative md:absolute;
          }
        }
      }
    }
  }
}
</style>
